import {
  AgeGroup,
  AgeGroupType,
  AgeGroupTypeColorMap,
  AgeGroupTypeNameMap,
  Colors,
} from './age_range';

/**
 * Raw age group data shape accepted by the conversion functions.
 * Matches common structures from domain models, DTOs, and view models.
 */
export interface RawAgeGroup {
  ageGroupId: string;
  type: string;
  maxAge: number;
  maxWeight: number;
  observations?: string;
}

/**
 * Converts a raw age group record into a fully enriched `AgeGroup`
 * with resolved display name and color.
 */
export function toAgeGroup(raw: RawAgeGroup): AgeGroup {
  const type = raw.type as AgeGroupType;
  const rv = {
    ...raw,
    ageGroupId: raw.ageGroupId,
    name: AgeGroupTypeNameMap.get(type) ?? raw.type,
    type,
    maxAge: raw.maxAge,
    maxWeight: raw.maxWeight,
    color: AgeGroupTypeColorMap.get(type) ?? Colors.grey,
    ...(raw.observations != null ? { observations: raw.observations } : {}),
  };
  return rv;
}

/**
 * Builds a `Map<string, AgeGroup>` keyed by `ageGroupId` from a list
 * of raw age group records.
 */
export function buildAgeGroupMap(items: RawAgeGroup[]): Map<string, AgeGroup> {
  return new Map(items.map((item) => [item.ageGroupId, toAgeGroup(item)]));
}
